import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

const apiURL = process.env.VUE_APP_API_URL || 'https://api.squaregames.ly/api'
const baseURL = apiURL.replace(/\/$/, '')

let echoInstance = null

function getToken() {
    return localStorage.getItem('client/user-token')
}

export function initEcho() {
    const token = getToken()

    if (!token) {
        console.warn('Echo not initialized: missing user token')
        return null
    }

    if (echoInstance) {
        echoInstance.disconnect()
        echoInstance = null
    }

    echoInstance = new Echo({
        broadcaster: 'reverb',
        key: process.env.VUE_APP_REVERB_APP_KEY,

        wsHost: process.env.VUE_APP_REVERB_HOST,
        wsPort: Number(process.env.VUE_APP_REVERB_PORT || 80),
        wssPort: Number(process.env.VUE_APP_REVERB_PORT || 443),

        forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',
        enabledTransports: ['ws', 'wss'],
        disableStats: true,

        authEndpoint: `${baseURL}/broadcasting/auth`,

        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            },
        },
    })

    window.Echo = echoInstance

    return echoInstance
}

export function getEcho() {
    if (!echoInstance) {
        return initEcho()
    }

    return echoInstance
}

export function disconnectEcho() {
    if (echoInstance) {
        echoInstance.disconnect()
        echoInstance = null
    }

    window.Echo = null
}

export default getEcho